<template>
    <p-inc-mail-menu-content
        @search = "onSearch"
    >
        <template v-slot:content>
            <v-list>
                <v-list-item
                    v-for="(item, index) in templates"
                    @click="onSelect(item)"
                    :key="index"
                    class="template-item"
                >
                    <v-list-item-title
                        @click="onSelect"
                    >
                        {{ item.name }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </template>
    </p-inc-mail-menu-content>
</template>

<script>

import Mail from "@/modules/inc/mail/service/Mail";
import Template from "@/modules/msd/templates/service/Template";
import PIncMailMenuContent from "@/modules/inc/mail/private/PIncMailMenuContent.vue";

export default {
    name: "PIncTemplateList",

    components: {
        PIncMailMenuContent
    },

    props: {
        index: {

        },

        step: {

        },
    },

    data: () => ({
        searchtext: "",
        templates: [],
        filtered: [],
    }),

    created() {
        Template.loadTemplates(this.site.customer.id, true, (data) => {
            this.templates = data.filter(item => !item.deleted);
        });
    },

    computed: {
        site () {
            return this.$store.getters.site;
        },

        incident () {
            return this.$store.getters.incident;
        }
    },

    methods: {
        onSelect (item) {
            if (!item || !item.id) {
                return;
            }

            Mail.resolve (item.id, this.index, this.step, this.site, this.incident, (data) => {
                this.$emit("template", data)
            });
        },

        onSearch (text) {
            console.log("search", text);
        }
    }
}
</script>

<style scoped>

.template-menu {
    width: 400px;
    background-color: white;
}

.template-item {
    cursor: pointer;
}

</style>